module.exports = __webpack_public_path__ + "static/img/3.94d7ae1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/3.png
// module id = esxT
// module chunks = 0